const Theme = {
  logo_image_url: 'lmi.png',
  logo_height: 115,

  body_background_color: '#F2295A',

  number_font: `'Poppins', sans-serif`,
  text_font: `'Poppins', serif`,
  text_weight:400,

  title_font: `'Poppins', sans-serif`,
  title_weight:700,

  subtitle_font: `'Poppins', sans-serif`,
  subtitle_weight:600,

  button_radius: 50,
  button_font: `'Poppins', serif`,
  button_border_width:2,
  button_color: '#F2295A',
}
export default Theme